import { FC } from 'react';
import { Trans } from 'react-i18next';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';

import { Icon } from '@components/base';

const FilterDateExpressionHint: FC = () => {
  return (
    <InputAdornment position='start'>
      <Tooltip
        title={
          <Trans
            components={{ strong: <strong />, ul: <ul />, li: <li /> }}
            i18nKey='dateInputMode.exp.tooltip'
          />
        }
      >
        <IconButton onClick={() => void 0} size='small'>
          <Icon fontSize='inherit' name='help' />
        </IconButton>
      </Tooltip>
    </InputAdornment>
  );
};

export default FilterDateExpressionHint;
